
import { ReactElement, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getLabelFallback, getSubtotal, convertNumber } from '@utils/utils';

const AffirmCard = () : ReactElement => {
    const config = useSelector(state => state.cart.config);
    const cart = useSelector(state => state.cart.cart);

    useEffect(() => {
        if(!!cart && !!window.affirm) {
            window.affirm.ui.ready(function() {
                window.affirm.checkout({
                    total: parseFloat(convertNumber(cart.grandTotal)) * 100
                });
    
                window.affirm.checkout.inline({
                    merchant: {
                      inline_container: "custom-inline-checkout-container"
                    },
                });
          
            })
        }       
    }, [cart, window.affirm]);

    const affirmInitiateCheckout = () => {
        const affirmInitiateCheckoutURL = config.hostname + 
            config.affirm.initiateCheckoutTemplateURL.replace('{{0}}', config.catalogId)
            .replace('{{1}}', config.langId)
            .replace('{{2}}', config.storeId)
            .replace('{{3}}', cart.orderId);

        const affirmAuthorizeURL = config.hostname + config.affirm.authorizeTemplateURL.replace('{{0}}', config.catalogId)
            .replace('{{1}}', config.langId)
            .replace('{{2}}', config.storeId)
            .replace('{{3}}', cart.orderId) as string;

        let affirmOnPopupClose = function() {
            /* @ts-expect-error */
            window.location = decodeURIComponent(res.affirmPaymentURL);
      };
      
      let affirmOnPopupError = function() {
          affirmOnPopupClose();
          // $(".inventory-block-message-container.hide:has(> #affirmMsgErrorPayment), #affirmMsgErrorPayment.error.hide").removeClass("hide");
            window?.tealium_data2track?.push({
               id: 'Event',
               Events_Error: '1',
               Error_Code: 'Checkout - Payment',
               Error_Details: 'Affirm',
               Error_Source: 'Server',
               Error_Message: 'Affirm checkout error'
               });
      };
      
      $(".affirm-overlay").show();
      
      $.ajax({
            type: "POST",
            url: affirmInitiateCheckoutURL,
            data: {
                "affirmAuthorizeURL" : affirmAuthorizeURL
            },
            success: function(res) {
                if (res.affirmToken != undefined) {
                    window.affirm.checkout({
                        "checkoutAri": res.affirmToken,
                        "metadata": {
                            "mode": "modal"
                        }
                    });
                    window.affirm.ui.ready(function() {
                      /*
                       * Errors generated by the checkout request are presented on the page where checkout is initiated, in the form of a pop-up modal window.
                       * Specific messaging about the source of the error is presented in this modal (e.g., "Invalid phone number").
                       * NOTE: This happens when we do not pass through CyberSource, so this callback may be useless.
                       */
                        window.affirm.ui.error.on("close",function() {
                            affirmOnPopupClose();
                        });
                    });
                    window.affirm.checkout.open({
                        onFail: function(a){
                            if (a.reason == "canceled") {
                                affirmOnPopupClose();
                            } else {
                                affirmOnPopupError();
                            }
                        },
                        onSuccess: function(a){
                            /* @ts-expect-error */
                            window.location = affirmAuthorizeURL + "&affirmToken="+res.affirmToken+"&requestID="+res.requestID+"&requestToken="+res.requestToken;
                        }
                    });
                } else {
                    /* @ts-expect-error */
                    window.location = (decodeURIComponent(res.affirmErrorURL));
                }
            },
            error: function(res) {
                affirmOnPopupError();
            },
            dataType: "json"
          });
    }

    useEffect(() => {
        setTimeout(() => {
            if(!!document.querySelector('#custom-inline-checkout-container iframe')) {
                document.querySelector('#custom-inline-checkout-container iframe').setAttribute('tabindex', '-1');
            }            
        }, 2000);
        
    }, []);

    return(
        <>
            {!!cart && parseFloat(getSubtotal(cart)) >= parseFloat(config.affirm.totalThresholdVal) ?
                <div className="affirm-card">
                    <label className="">{ getLabelFallback('AFFIRM_CLAIM_PAYMENT_LABEL') } <span>{!!cart && getLabelFallback('CURRENCY_LABEL')}{!!cart && convertNumber(cart.grandTotal/config.affirmCountPayment)} </span></label>
                    <div id="custom-inline-checkout-container"></div>
                    <div className="affirm-overlay"></div>
                    <button className="violet-button" onClick={affirmInitiateCheckout}>{ getLabelFallback('PAY_CONFIRM_BUTTON_LABEL') }</button>
                </div> :
                getLabelFallback('NOT_AVAILABLE_LABEL')
            }
        </>                
    )
}

export default AffirmCard;
